import { ISwitchComponent } from './interface';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const SwitchComponent = (props: ISwitchComponent) => {
  const { roles, type, redirect, children } = props;

  const user = useSelector((state: any) => state.user);
  const navigate = useNavigate();

  const userRoles = user.roles;
  const { userType } = user;

  if (userRoles && roles?.includes(userRoles[0]) && type?.includes(userType)) {
    return children;
  }
  return redirect ? null && navigate(`${redirect}`) : null;
};

export default SwitchComponent;
